/**
 * compact page list with first, last, current ±1, and `gap` placeholders
 * for the elided ranges. totalPages <= 7 returns the full list, beyond
 * that the window collapses around the current page.
 */
export function pageWindow(current: number, total: number): (number | 'gap')[] {
  if (total <= 7) {
    return Array.from({ length: total }, (_, index) => index + 1)
  }
  const pages: (number | 'gap')[] = [1]
  const start = Math.max(2, current - 1)
  const end = Math.min(total - 1, current + 1)
  if (start > 2) pages.push('gap')
  for (let page = start; page <= end; page++) pages.push(page)
  if (end < total - 1) pages.push('gap')
  pages.push(total)
  return pages
}
